import type { ShippingForRouting } from '../models/routing.types';
import { VisitType } from '../models/routing.types';

export function isPickupShipping(shipping: ShippingForRouting): boolean {
  if (shipping.visitType === VisitType.PICKUP) return true;
  const name = (
    shipping.commercialService?.name ||
    shipping.commercialService?.commercialName ||
    shipping.serviceVisitTypeName ||
    ''
  ).toLowerCase();
  return name.includes('retiro');
}

export function getAddressForShipping(shipping: ShippingForRouting) {
  if (isPickupShipping(shipping)) {
    return shipping.originAddress || shipping.destinationAddress;
  }
  return shipping.destinationAddress || shipping.originAddress;
}
